import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyClubContext } from '@contexts/company-club/company-club-context';

export const useEventCreationRevoked = () => {
  const { t } = useTranslation();
  const { venueAccess, isAddOrganizerToVenueActive, isAddOrganizerToVenueLoading } = useContext(CompanyClubContext);
  const isAccessRevoked = venueAccess?.isRevoked ?? false;
  const venueName = venueAccess?.venueName ?? '';

  return {
    isEventCreationRevoked: isAddOrganizerToVenueActive && isAccessRevoked,
    // Only a revoked venue waits on the flag: PostHog may never answer (no token, quota hit).
    isEventCreationPending: venueAccess === null || (isAccessRevoked && isAddOrganizerToVenueLoading),
    revokedReason: t('eventList:revokedCreateEventReason', { venue: venueName }),
    venueName,
  };
};
